import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpErrorResponse } from '@angular/common/http';
import { environment } from '@environments/environment';
import { ApiResponse } from '@app/_models';
import { retry, catchError } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { AlertService } from '@app/_services';
import { SharedService } from './../_shared/shared.service';
import {Contact} from '@app/_components/contact/contact';

@Injectable({ providedIn: 'root' })
export class ContactService {

	statuses: any = [
		{ value: '01', name: 'Condo' },
		{ value: '16', name: 'Townhome' },
		{ value: '14', name: 'House' }
	];

	ownersList: any = [
		{ value: '1', name: 'Primary' },
		{ value: '2', name: 'Vacation' },
		{ value: '3', name: 'Investment' }
	];

	constructor
		(
			private http: HttpClient,
			private alertService: AlertService,
			private sharedService: SharedService,
		) { }

	urlEndpoint = 'contacts';

	add(contact: Contact): Observable<ApiResponse> {
		console.log('posting... ' + JSON.stringify(contact));
		return this.http.post<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}`, contact);
	}

	importContacts(contactdata: any): Observable<ApiResponse> {
		console.log('posting... ' + JSON.stringify(contactdata));
		return this.http.post<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/import`, contactdata);
	}

	update(contact: Contact): Observable<ApiResponse> {
		return this.http.patch<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}`, contact);
	}

	delete(developmentId: number): Observable<ApiResponse> {
		return this.http.delete<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/${developmentId}`);
	}

	findAll(): Observable<ApiResponse> {
		return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/find-all`).pipe(retry({ count: 2, delay: 1500 }));
	}

	getFilterData(): Observable<ApiResponse> {
		return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/filterData`).pipe(retry({ count: 2, delay: 1500 }));
	}

	findByFilter(page: any, size: any, sortBy: any, sortOrder: any, multiSortMeta, globalFilter: any, filters: any): Observable<ApiResponse> {
		let params = this.sharedService.prepareParamsFromPrimeNgDataTable(page, size, sortBy, sortOrder, multiSortMeta, globalFilter, filters);
		console.log('posting... ' + JSON.stringify(filters));
		return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}`, { params: params }).pipe(retry({ count: 2, delay: 1500 }));

	}

  fetchAllContacts(page: any, size: any, sortBy: any, sortOrder: any, multiSortMeta, globalFilter: any, filters: any): Observable<ApiResponse> {
    let params = this.sharedService.prepareParamsFromPrimeNgDataTable(page, size, sortBy, sortOrder, multiSortMeta, globalFilter, filters);
    console.log('posting... ' + JSON.stringify(filters));
    return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/fetchwithoutpage`, { params: params }).pipe(retry({ count: 2, delay: 1500 }));

  }

	findById(id: number): Observable<ApiResponse> {
		return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/${id}`).pipe(retry({ count: 2, delay: 1500 }));
	}

	audit(id: number): Observable<ApiResponse> {
		return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/${id}/audit`).pipe(retry({ count: 2, delay: 1500 }));
	}

}
